










import Vue from 'vue';
import { LightStatus } from '@/store';
import ActionButton from '@/components/common/ActionButton.vue';
import WindowCloseReason from '@/enums/WindowCloseReason';
import DeviceType from '@/enums/DeviceType';
export default Vue.extend({
  name: 'CriticalFail',
  components: {
    ActionButton,
  },
  computed: {
    criticalErrorDescription(): string {
      switch (this.$store.state.deviceType) {
        case DeviceType.Light:
          return Vue.i18n.translate('Critical_Fail_Description_Light') || '';
        case DeviceType.Plug:
          return Vue.i18n.translate('Critical_Fail_Description_Plug') || '';
        case DeviceType.WiFiSwitch:
          return (
            Vue.i18n.translate('Critical_Fail_Description_WiFi_Switch') || ''
          );
      }
      return '';
    },
  },
  methods: {
    tryAgain() {
      (<any>window).closeReason = WindowCloseReason.CriticalFail;
      window.close();
    },
  },
});



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/CriticalFail.vue